import React, { useEffect, useState } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import './ToolDetails.css';

const ToolDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  const passedTool = location.state?.tool;

  const [tool, setTool] = useState(passedTool || null);
  const [isVideoLoading, setIsVideoLoading] = useState(true);

  useEffect(() => {
    if (tool) return;

    const fetchTool = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/tools/${id}`);
        const data = await response.json();
        setTool(data);
      } catch (error) {
        console.error('Error fetching tool details:', error);
      }
    };

    fetchTool();
  }, [id, tool]);

  if (!tool) {
    return <div className="tool-details-container">Loading...</div>;
  }

  // ✅ Extract YouTube video ID safely
  const getYoutubeId = (url) => {
    try {
      const id = new URLSearchParams(new URL(url).search).get('v');
      return id;
    } catch {
      return null;
    }
  };

  const youtubeId = getYoutubeId(tool.demoVideo);

  return (
    <div className="tool-details-container">
      <button className="back-btn" onClick={() => navigate(-1)}>
        ← Back
      </button>

      <h2 className="tool-name">{tool.name}</h2>

      {youtubeId ? (
        <div className="video-container">
          <div className="video-wrapper">
            {isVideoLoading && (
              <div className="video-loading-overlay">
                <p className="loading-text">Loading video...</p>
              </div>
            )}
            <iframe
              className={`video-iframe ${isVideoLoading ? 'hidden' : ''}`}
              src={`https://www.youtube.com/embed/${youtubeId}`}
              title={tool.name}
              allowFullScreen
              onLoad={() => setIsVideoLoading(false)}
            ></iframe>
          </div>
        </div>
      ) : (
        <div className="video-unavailable">
          <p>❌ Demo video is not available for this tool.</p>
        </div>
      )}

      <button
        className="try-now-btn"
        onClick={() => window.open(tool.website, '_blank')}
      >
        Try Now
      </button>
    </div>
  );
};

export default ToolDetails;
